"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulingReducer = exports.haulingAction = exports.haulingTypes = void 0;
const hauling_component_1 = __importDefault(require("./sub-components/hauling.component"));
const hauling_action_1 = __importDefault(require("./hauling.action"));
exports.haulingAction = hauling_action_1.default;
const hauling_reducer_1 = __importDefault(require("./hauling.reducer"));
exports.haulingReducer = hauling_reducer_1.default;
const hauling_types_1 = require("./hauling.types");
Object.defineProperty(exports, "haulingTypes", { enumerable: true, get: function () { return hauling_types_1.haulingTypes; } });
exports.default = hauling_component_1.default;
